var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCtaDot2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5",
    "data-name": "Group 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82.096,
    height: 105.836,
    viewBox: "0 0 82.096 105.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 82.096,
    height: 105.836,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M80.488,3.216A1.609,1.609,0,1,1,82.1,1.608a1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M64.712,3.216A1.609,1.609,0,1,1,66.32,1.608a1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M64.712,23.74a1.608,1.608,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M48.936,3.216a1.609,1.609,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M48.936,23.74a1.608,1.608,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M48.936,44.264a1.608,1.608,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M33.16,3.216a1.609,1.609,0,1,1,1.608-1.608A1.608,1.608,0,0,1,33.16,3.216",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M33.16,23.74a1.608,1.608,0,1,1,1.608-1.608A1.608,1.608,0,0,1,33.16,23.74",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M33.16,44.264a1.608,1.608,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M33.16,64.788a1.608,1.608,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M17.384,3.216a1.609,1.609,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M17.384,23.74a1.608,1.608,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M17.384,44.264a1.608,1.608,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M17.384,64.788a1.608,1.608,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M17.384,85.312A1.608,1.608,0,1,1,18.992,83.7a1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1.608,3.216A1.609,1.609,0,1,1,3.216,1.608,1.608,1.608,0,0,1,1.608,3.216",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1.608,23.74a1.608,1.608,0,1,1,1.608-1.608A1.608,1.608,0,0,1,1.608,23.74",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1.608,44.264a1.608,1.608,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1.608,64.788A1.608,1.608,0,1,1,3.216,63.18a1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1.608,85.312A1.608,1.608,0,1,1,3.216,83.7a1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1.608,105.836a1.608,1.608,0,1,1,1.608-1.608,1.608,1.608,0,0,1-1.608,1.608",
    fill: "#264796"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaDot2);
export default __webpack_public_path__ + "static/media/cta-dot2.6771824b90ac0fb951fc2ada864792df.svg";
export { ForwardRef as ReactComponent };